import { render } from "./index1.vue?vue&type=template&id=20390eb5&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"

import "./index1.vue?vue&type=style&index=0&id=20390eb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20390eb5"]])

export default __exports__